module.exports = __webpack_public_path__ + "static/img/gameBox.37f6a82.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sportsBetting/gameBox.webp
// module id = R28S
// module chunks = 0